export const ssr = true
export const prerender = true
